import { Navigate } from 'react-router-dom';
import type { AccountType } from '../api/types';

export function HomeRedirect({ meAccountType, isLoading }: { meAccountType?: AccountType; isLoading: boolean }) {
  if (isLoading) return null;
  return <Navigate to={meAccountType === 'community' ? '/community' : '/clients'} replace />;
}
